import spinner from '../assets/svg/Spinners.svg'

const ButtonLoader = () => {
  return (
    <div className="flex justify-center items-center z-index-90">
        <div>
            <img src={spinner} alt="loading..." className='h-[30px] w-[30px]' />
        </div>
    </div>
  )
}

export default ButtonLoader